import { render, staticRenderFns } from "./activity-4.vue?vue&type=template&id=2e308c9b&scoped=true&"
import script from "./activity-4.vue?vue&type=script&lang=js&"
export * from "./activity-4.vue?vue&type=script&lang=js&"
import style0 from "./activity-4.vue?vue&type=style&index=0&id=2e308c9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e308c9b",
  null
  
)

export default component.exports